import { Typography } from 'antd';
import { ColumnsType } from 'antd/es/table';
import moment from 'moment';

const { Text } = Typography;

export const uploadRecordColumns: ColumnsType<any> = [
  { key: 'employeeFirstName', title: 'First Name', dataIndex: 'employeeFirstName', width: 150, render: (v) => v || '-' },
  { key: 'employeeFamilyName', title: 'Family Name', dataIndex: 'employeeFamilyName', width: 150, render: (v) => v || '-' },
  { key: 'employeePPSN', title: 'PPS Number', dataIndex: 'employeePPSN', width: 150, render: (v) => v || '-' },
  { key: 'employmentID', title: 'Employment ID', dataIndex: 'employmentID', width: 150, render: (v) => v || '-' },
  { key: 'aepnNumber', title: 'AEPN Number', dataIndex: 'aepnNumber', width: 150, render: (v) => v || '-' },
  { key: 'enrolmentStatus', title: 'Enrolment Status', dataIndex: 'enrolmentStatus', align: 'center', width: 180, render: (v) => v || '-' },
  {
    key: 'aepnEnrolmentDate', title: 'Enrolment Date', dataIndex: 'aepnEnrolmentDate', align: 'right', width: 160,
    render: (v) => v ? moment(v).format('DD/MM/YYYY') : '-',
  },
  {
    key: 'aepnIssueDate', title: 'Issue Date', dataIndex: 'aepnIssueDate', align: 'right', width: 140,
    render: (v) => v ? moment(v).format('DD/MM/YYYY') : '-',
  },
  { key: 'aepnChangeEvent', title: 'Change Event', dataIndex: 'aepnChangeEvent', width: 160, render: (v) => v || '-' },
  { key: 'eeContributionRate', title: 'EE Rate', dataIndex: 'eeContributionRate', align: 'right', width: 100, render: (v) => v ?? 0 },
  { key: 'erContributionRate', title: 'ER Rate', dataIndex: 'erContributionRate', align: 'right', width: 100, render: (v) => v ?? 0 },
  {
    key: 'errorMessage', title: 'Error', dataIndex: 'errorMessage', width: 300,
    render: (v) => v ? <Text type="danger">{v}</Text> : '-',
  },
];
